module.exports = __webpack_public_path__ + "5405bee1a17824bb27942b21c8952d6d.svg";